import { LargeListSkeleton } from '@Components/General/Skeletons';
import { createFileRoute } from '@tanstack/react-router';
import { emailsScheduledQueryOptions } from '@utils/queryOptions';
import EmailsScheduled from '@Views/Emails/scheduled';

export const Route = createFileRoute('/emails/scheduled/')({
    component: EmailsScheduled,
    loader: opts =>
        opts.context.queryClient.ensureQueryData(
            emailsScheduledQueryOptions(opts.deps),
        ),
    loaderDeps: ({ search }) => search,
    pendingComponent: LargeListSkeleton,
});
